import axios from 'axios';
import { API_URL } from '@/app/api/constants.ts';
import { useErrorStore } from '@/app/zustand/errors.ts';

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
});

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const message = error.response?.data?.error || error.message || error.code;
    useErrorStore.setState({ message });
    return Promise.reject(error);
  }
);

export default api;
